import Braze from 'appboy-web-sdk';
import env from 'src/env';

const baseUrl = 'https://sdk.iad-03.braze.com/api/v3';

const isEnabled = () => Boolean(env.BRAZE_API_KEY);

const initialize = () =>
  Braze.initialize(env.BRAZE_API_KEY, { baseUrl /* , enableLogging: true */ });

interface UserProfile {
  email: string;
}

const initializeUserSession = (userProfile: UserProfile) => {
  if (!isEnabled()) return;

  const { email } = userProfile;

  Braze.changeUser(email);
  Braze.getUser().setEmail(email);
  Braze.display.automaticallyShowNewInAppMessages();
  Braze.openSession();
};

export default {
  baseUrl,
  initialize,
  initializeUserSession,
  isEnabled,
};
